<mat-label class="subHeading ">Seating Capacity</mat-label>
<div formGroupName="seating_capacity" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="1" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="1" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        seatingCapacityForm.controls['from'].hasError('small')
        ||
        seatingCapacityForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
